const repairDollars = (value: string): string => {
  const [whole, ...fractions] = value.replace(/[^\d.]/g, '').split('.');
  if (fractions.length === 0) return whole;
  return `${whole}.${fractions.join('').slice(0, 2)}`;
};

export default repairDollars;
